// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "OnboardingSummary__textCenter__y20K5";
export const section = "OnboardingSummary__section__vjB8M";
export const profileCompact = "OnboardingSummary__profileCompact__pBb1a";
export const header = "OnboardingSummary__header__8eIJo";
export const compareHeader = "OnboardingSummary__compareHeader__IefZ-";
export const you = "OnboardingSummary__you__G8UJl font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const peers = "OnboardingSummary__peers__h2LNi font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const peersSubtitle = "OnboardingSummary__peersSubtitle__xIX1F";
export const compare = "OnboardingSummary__compare__0bU7f";
export const divider = "OnboardingSummary__divider__urJJL";
export const compareColumn = "OnboardingSummary__compareColumn__S24dN";
export const compareLeft = "OnboardingSummary__compareLeft__2JeWB OnboardingSummary__compareColumn__S24dN";
export const compareRight = "OnboardingSummary__compareRight__CvIOc OnboardingSummary__compareColumn__S24dN";
export const blocks = "OnboardingSummary__blocks__EiMOg";
export const block = "OnboardingSummary__block__stfd1";
export const blockTitle = "OnboardingSummary__blockTitle__gUAh1 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const blockBody = "OnboardingSummary__blockBody__cX4LF font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const toDashboard = "OnboardingSummary__toDashboard__vhbtY font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const toSettings = "OnboardingSummary__toSettings__u0R8o";